import React from "react";
import { StyledSpan } from "./styles";

/**
 * Standardized "required" mark for the form fields
 */
export const Required = () => <StyledSpan> *</StyledSpan>;
